import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { List, ListItemIcon, ListItemText, Tooltip, ListItemButton } from '@mui/material';
import { DrawerMenuItem } from 'models/navigation';
import { useTranslation } from 'react-i18next';

type DrawerMenuProps = {
    menu: DrawerMenuItem[];
    onNavigation: () => void;
};
const DrawerMenu: FC<DrawerMenuProps> = ({ menu, onNavigation }: DrawerMenuProps) => {
    const { t: translate } = useTranslation(['common']);

    return (
        <List
            sx={{
                overflow: 'hidden',
                height: '100%',
                marginTop: '65px',
            }}
        >
            {menu.map(({ Icon, name, url, isVisible, isNewOrder }, index) =>
                isVisible ? (
                    <Tooltip key={index} title={name} placement="right">
                        <NavLink
                            to={url}
                            key={url}
                            onClick={onNavigation}
                            type="button"
                            style={{
                                textDecoration: 'none',
                            }}
                            data-test={`drawer-menu.nav-link${url.replace(/\//g, '-')}`}
                        >
                            <ListItemButton>
                                <ListItemIcon sx={isNewOrder ? (theme) => ({ color: theme.palette.calm.main }) : {}}>
                                    <Icon />
                                </ListItemIcon>
                                <ListItemText
                                    sx={(theme) => ({
                                        color: theme.palette.text.primary,
                                    })}
                                    primary={name}
                                />
                            </ListItemButton>
                        </NavLink>
                    </Tooltip>
                ) : undefined,
            )}
        </List>
    );
};

export default DrawerMenu;
